module.exports = __webpack_public_path__ + "static/media/6.Electric Lawnmower.72348b0f.jpg";